import { latLng, icon } from "leaflet";

export const environment = {
  production: true,

  map_sw: latLng(49.749583, 19.138051),
  map_ne: latLng(49.953792, 19.525098),
  map_center: [49.854894, 19.341200],
  map_zoom: 15,
  
  logo: "",
  
  line_module: true,

  api_url: 'http://45.90.2.104:8080/api/',
  server_url: 'http://45.90.2.104/',
  carrierSelectGuard: true,
  
  languages_de: true,
  one_carrier_only: true,

  stopIcon: icon({
    iconUrl: 'assets/images/stop.png',
    iconSize: [32, 32]
  }),

  busIcon: icon({
    iconUrl: 'assets/images/32x32.png',
    iconSize: [32, 32]
  }),

  carrier_name_overwrite: "ZKM Andrychów",

};
